// src/admin/components/TagSelector.jsx

import { useState } from "react";

import useTags from "../hooks/useTags";

export default function TagSelector({
  selectedTags = [],
  onChange,
}) {

  const {
    tags,
    createTag,
  } = useTags();

  const [search, setSearch] =
    useState("");

  const filteredTags =
    tags.filter((tag) =>
      tag.name
        .toLowerCase()
        .includes(
          search.toLowerCase()
        )
    );

  const addTag = (tag) => {

    if (
      selectedTags.some(
        (t) => t.id === tag.id
      )
    ) {
      return;
    }

    onChange([
      ...selectedTags,
      tag,
    ]);

    setSearch("");
  };

  const removeTag = (id) => {

    onChange(
      selectedTags.filter(
        (tag) => tag.id !== id
      )
    );
  };

  const handleCreateTag =
    async () => {

      if (!search.trim()) {
        return;
      }

      const newTag =
        await createTag(search);

      addTag(newTag);
    };

  return (
    <div className="space-y-3">

      {/* Selected tags */}

      <div className="flex flex-wrap gap-2">

        {selectedTags.map((tag) => (

          <span
            key={tag.id}
            className="
              px-3
              py-1
              rounded-full
              bg-cyan-500/20
              text-cyan-500
              text-sm
              flex
              items-center
              gap-2
            "
          >
            {tag.name}

            <button
              type="button"
              onClick={() =>
                removeTag(tag.id)
              }
            >
              ×
            </button>

          </span>

        ))}

      </div>

      {/* Search */}

      <input
        type="text"
        value={search}
        onChange={(e) =>
          setSearch(
            e.target.value
          )
        }
        placeholder="Search tags..."
        className="
          bg-transparent
          text-gray-700
          w-full
          px-4
          py-3
          rounded-xl
          border
        "
      />

      {/* Suggestions */}

      {search && (

        <div
          className="
            max-h-48
            overflow-y-auto
            border
            rounded-xl
          "
        >

          {filteredTags.map((tag) => (

            <button
              key={tag.id}
              type="button"
              onClick={() =>
                addTag(tag)
              }
              className="
                w-full
                text-left
                px-4
                py-2
                hover:bg-gray-100
              "
            >
              {tag.name}
            </button>

          ))}

          {!filteredTags.length && (

            <button
              type="button"
              onClick={
                handleCreateTag
              }
              className="
                w-full
                text-left
                px-4
                py-2
                text-cyan-500
              "
            >
              Create "{search}"
            </button>

          )}

        </div>

      )}

    </div>
  );
}